export default {"src":"/_next/static/media/client-2-1.90d6796d.svg","height":40,"width":205,"blurWidth":0,"blurHeight":0};